import { Controller } from '@hotwired/stimulus'
import { headers } from '../../src/js/csrf'
import { getParents } from '../../src/js/helpers'
import '../../src/css/modules/swiper.scss'
import {
  AwsS3Multipart,
  Core,
  Dashboard
} from "uppy"
import '../../src/css/modules/uppy.scss'

export default class extends Controller {
  static targets = [
    'projectForm',
    'nameValue',
    'similarFavoritesButton',
    'similarSocialButton',
    'similarViedit',
    'similarSocial',
    'similarInput',
    'thumb',
    'errorLink',
    'similar',

    'audio1',
    'audio2',
    'audioFirstAnnotations',
    'audioSecondAnnotations',

    'instructions',
    'musicNameField',
    'voiceLang',
    'audioField',
    'whoViewSelect',
    'whoViewAnnotations',
    'redirectUrl',
    'attachments',
    'attachment',
    'dynamicLeaveButton',
    'modal',
    'holder'
  ]

  initialize() {
    // if (this.audioFieldTarget) this.setAudioFieldValue()
    // to show 'save draft' modal on outside links
    this.initUppy()
    // Store bound function reference for cleanup
    this.boundLinkClickHandler = this.linkClickHandler.bind(this)
    this.outsideLinksListener()
    // close modal on back button
    this.backButtonCloseModal()
    this.initSwiper()
  }

  disconnect() {
    // Clean up event listeners to prevent memory leaks and duplicate handlers
    this.removeOutsideLinksListener()
  }

  // dynamic import
  initSwiper() {
    import('swiper').then(swiper => {
      const Swiper = swiper.default
      new Swiper('.swiper-container', {
        // Optional parameters
        // creating duplicates which is bad for checkboxes
        // loop: true,
        lazy: true,
        slidesPerView: 2,
        // autoHeight: true,
        // height: 200,
        centeredSlides: true,
        grabCursor: true,
        spaceBetween: 10,
        // autoplay: {
        //   delay: 2500,
        //   // autoplay will not be disabled after user interactions (swipes)
        //   // it will be restarted every time after interaction
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true,
        },
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // helping carousel to show the right amount of slides
        observer: true,
        observeParents: true,
      })
    })
  }

  initUppy() {
    this.uppy = Core({
      autoProceed: true,
      restrictions: {
        // 3Mb - 4.5Gb
        maxFileSize: 4_831_838_208,
        maxNumberOfFiles: 50,
      },
    })
      .use(AwsS3Multipart, {
        companionUrl: '/',
      })
      .use(Dashboard, {
        target: this.holderTarget,
        height: 300,
        proudlyDisplayPoweredByUppy: false,
        inline: true
      })

    this.uppy.on('upload-success', this.uploadSuccess.bind(this))
  }

  uploadSuccess(file, response) {
    const fileData = {
      id: response.uploadURL.match(/\/cache\/([^\?]+)/)[1], // extract key without prefix
      storage: 'cache',
      metadata: {
        size:      file.size,
        filename:  file.name,
        mime_type: file.type,
      }
    }
    fetch('/uploads', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        upload: {
          upl: fileData
        }
      })
    }).then(response => {
      if (!response.ok) throw response
      return response.json()
    }).then(res => {
      this.attachmentsTarget.insertAdjacentHTML('beforeend', res.html)
    }).catch(err => {
      err.json().then(body => console.error('we got an error: ', body))
    })
  }

  // action
  // both enter in text field and button
  addSimilar(e) {
    this.errorLinkTarget.classList.add('d-none')
    this.similarInputTarget.classList.remove('is-invalid')
    let key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0
    if ((!(e.currentTarget === this.similarInputTarget) || e.keyCode === 13) && this.similarInputTarget.value !== '') {
      e.preventDefault()
      let inputLink = this.similarInputTarget.value
      let { provider, videoId } = this.generateInfo(inputLink)
      if (provider) {
        this.saveSocialVideo(provider, videoId)
        this.similarInputTarget.value = ''
      } else {
        this.errorLinkTarget.classList.remove('d-none')
        this.similarInputTarget.classList.add('is-invalid')
      }
    }
  }

  generateInfo(inputLink) {
    let videoId, provider
    if (inputLink.includes('youtu')) {
      // possible links to handle
      // https://www.youtube.com/watch?v=9t1nGNKdIgE
      // https://www.youtube.com/watch?v=9t1nGNKdIgE&t=1285s
      // https://youtu.be/9t1nGNKdIgE
      provider = 'youtube'
      videoId = inputLink.trim().split('/').slice(-1)[0].split('v=').slice(-1)[0].split('&')[0]
    } else if (inputLink.includes('vimeo')) {
      provider = 'vimeo'
      videoId = inputLink.trim().split('/').slice(-1)[0]
    }
    return { provider, videoId }
  }

  saveSocialVideo(provider, videoId) {
    fetch('/social_video_examples', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        social_video_example: {
          descriptor: videoId,
          provider: provider
        }
      })
    }).then(response => {
      if (!response.ok) {
        response.json().then(json => { throw json }) // throwing to catch block
      }
      return response.json() // we only get here if there is no error
    }).then(res => {
      this.thumbTarget.insertAdjacentHTML('afterbegin', res.html)
    }).catch(err => console.error('we got an error: ', err))
  }

  destroySimilar(event) {
    let socialVideoId = event.currentTarget.dataset.similarId
    let similarHolder = event.currentTarget.closest('.similar__video')
    fetch('/social_video_examples/' + socialVideoId, {
      method: 'delete',
      headers: headers,
    }).then(res => {
      if (res.ok) {
        similarHolder.remove()
      }
    }).catch(error => console.error("we got an error:", error))
  }

  // start of audio handle

  // action (audio selection)
  audioAction(event) {
    if (getParents(event.currentTarget).includes(this.audio1Target)) {
      this.showFirstAnnotation(event.currentTarget.dataset.number)
    } else {
      this.showSecondAnnotation(event.currentTarget.dataset.number)
    }
    // need some time for ':checked' attribute change
    setTimeout(() => {
      this.setAudioFieldValue()
    }, 100)
  }

  // show the right descriptions/field for music types
  showFirstAnnotation(chosenType) {
    [...this.audioFirstAnnotationsTarget.children].forEach(element => {
      element.classList.add('d-none')
      if (element.classList.contains(`atype-${chosenType}`)) {
        element.classList.remove('d-none')
      }
    })
    // hide all other selections if original audio
    if (chosenType === '1') {
      [this.audio2Target, this.audioSecondAnnotationsTarget, this.voiceLangTarget].forEach(element => {
        element.classList.add('d-none')
      })
    } else {
      this.audio2Target.classList.remove('d-none')
      this.audioSecondAnnotationsTarget.classList.remove('d-none')
    }
    if (chosenType === '3') {
      this.voiceLangTarget.classList.remove('d-none')
    } else {
      this.voiceLangTarget.classList.add('d-none')
    }
  }

  showSecondAnnotation(chosenType) {
    [...this.audioSecondAnnotationsTarget.children].forEach(element => {
      element.classList.add('d-none')
      if (element.classList.contains(`atype-${chosenType}`)) {
        element.classList.remove('d-none')
      }
    })
    this.audioSecondAnnotationsTarget.classList.remove('d-none')
  }

  audioCase() {
    const audioOne = this.audio1Target.querySelector('.btn-check:checked + .btn-outline-primary').dataset.number
    const audioTwo = this.audio2Target.querySelector('.btn-check:checked + .btn-outline-primary').dataset.number
    switch (audioOne) {
      case '1':
        return 'original'
      case '2':
        switch (audioTwo) {
          case '1':
            return 'music_nocopy'
          case '2':
            return 'music_name'
          case '3':
            return 'music_upload'
          default:
            return null
        }
      case '3':
        switch (audioTwo) {
          case '1':
            return 'both_nocopy'
          case '2':
            return 'both_name'
          case '3':
            return 'both_upload'
          default:
            return null
        }
      default:
        return null
    }
  }

  setAudioFieldValue() {
    this.audioFieldTarget.value = this.audioCase()
    console.log('final audio type value: ' + this.audioFieldTarget.value)
  }
  // end of audio handle

  // --- outside links handing ---
  outsideLinksListener() {
    // Only add listeners if we have the required targets (i.e., we're on a create project page)
    if (!this.hasProjectFormTarget || !this.hasModalTarget || !this.hasDynamicLeaveButtonTarget) {
      return
    }
    
    // Store references to elements with listeners for cleanup
    this.elementsWithListeners = []
    
    document.querySelectorAll('a').forEach(elem => {
      if (!getParents(elem).includes(this.projectFormTarget)) {
        elem.addEventListener('click', this.boundLinkClickHandler)
        this.elementsWithListeners.push(elem)
      }
    })
  }

  linkClickHandler(event) {
    // Safety check - ensure we have all required targets
    if (!this.hasModalTarget || !this.hasDynamicLeaveButtonTarget || !this.hasRedirectUrlTarget) {
      return
    }
    
    if (this.anyInfo()) {
      event.preventDefault()
      new Modal(this.modalTarget).show()
      this.dynamicLeaveButtonTarget.href = event.target.href
      // if customer want to close modal with back button
      window.history.pushState('forward', null, './create-project')
      this.redirectUrlTarget.value = event.target.href // handled by controller later
    }
  }

  removeOutsideLinksListener() {
    if (this.elementsWithListeners) {
      this.elementsWithListeners.forEach(elem => {
        elem.removeEventListener('click', this.boundLinkClickHandler)
      })
      this.elementsWithListeners = []
    }
  }

  backButtonCloseModal() {
    window.addEventListener('popstate', (_event) => {
      const el = document.getElementById('save-draft-confirm')
      if (!el) return
      const instance = window.bootstrap?.Modal.getOrCreateInstance(el)
      instance?.hide()
    })
  }

  // should be title and information
  // or title and uploads
  anyInfo() {
    return this.nameValueTarget.value !== '' && (this.instructionsTarget.value !== '' || this.hasAttachmentTarget)
  }
  // --- /outside links handing ---

  whoViewSelectAction() {
    this.showWhoViewAnnotation()
  }

  showWhoViewAnnotation() {
    let value = this.whoViewSelectTarget.value
    let chosenType = (value === 'all' || value === 'favorite') ? value : 'exclusive'
    Array.from(this.whoViewAnnotationsTarget.children).forEach(element => {
      element.classList.add('d-none')
      if (element.classList.contains(`mtype-${chosenType}`)) {
        element.classList.remove('d-none')
      }
    })
  }

  // action
  similarFavoritesAction() {
    this.similarFavoritesButtonTarget.classList.toggle('active')
    this.similarSocialButtonTarget.classList.remove('active')
    this.similarVieditTarget.classList.toggle('d-none')
    this.similarSocialTarget.classList.add('d-none')
    // fetch(this.urlValue)
    //   .then((r) => r.text())
    //   .then((html) => {
    //     const fragment = document.createRange().createContextualFragment(html)
    //     this.element.appendChild(fragment)
    //   })
  }

  // action
  similarSocialAction() {
    this.similarSocialButtonTarget.classList.toggle('active')
    this.similarFavoritesButtonTarget.classList.remove('active')
    this.similarSocialTarget.classList.toggle('d-none')
    this.similarVieditTarget.classList.add('d-none')
  }

  // action
  showForm(event) {
    let hiddenForm = event.currentTarget.closest('.js-checkbox').nextElementSibling
    if (hiddenForm.classList.contains('d-none')) {
      hiddenForm.classList.remove('d-none')
    } else {
      hiddenForm.classList.add('d-none')
      // reset value of all inputs
      hiddenForm.querySelectorAll('input').forEach((el) => {
        el.value = ''
      })
    }
  }

}
